import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/node_modules/next/dist/client/app-dir/link.js");
